export default __webpack_public_path__ + "static/media/6.641418a7.png";